import { useEffect } from "react";
import { setClientBrandFavicon } from "../theme/theme.tsx";

/**
 * Personaliza aba e chrome do portal com a marca do cliente.
 *
 * Título, cor da barra e favicon passam a ser do `/@handle`, não do produto.
 * Ao sair da rota, o ícone da Dream Calendar volta.
 */

export function useClientBrand(input: {
  name?: string;
  color?: string;
  logoUrl?: string | null;
}): void {
  const { name, color, logoUrl } = input;

  useEffect(() => {
    const previousTitle = document.title;
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const previousThemeColor = themeMeta?.getAttribute("content") ?? null;

    if (name !== undefined && name.trim() !== "") {
      document.title = `${name.trim()} · calendário`;
    }
    if (color !== undefined && color !== "") {
      themeMeta?.setAttribute("content", color);
    }
    setClientBrandFavicon(logoUrl ?? null);

    return () => {
      document.title = previousTitle;
      if (themeMeta !== null) {
        if (previousThemeColor === null) themeMeta.removeAttribute("content");
        else themeMeta.setAttribute("content", previousThemeColor);
      }
      setClientBrandFavicon(null);
    };
  }, [name, color, logoUrl]);
}
